import { EventListCardData } from '../../event/event-types';
import { isOnDemandEvent } from './is-on-demand-event';
import { isInPersonEvent } from './is-in-person-event';

export const isPastEvent = (event: EventListCardData) => {
    if (isOnDemandEvent(event)) {
        return false;
    }

    const eventDateStr = event?.eventDate || event?.date;
    if (!eventDateStr) {
        // No date to compare against — can't classify as past.
        return false;
    }

    // The `event_time` field is hidden in WP for in-person events (it's not meant
    // to apply to them), so its stored value is unreliable and must be ignored.
    // For every other type, only use the time if it actually parses — a missing or
    // unparseable time (e.g. null) must never poison the comparison and silently
    // leave a past event in the "upcoming" bucket.
    const eventTime = isInPersonEvent(event) ? undefined : event?.eventTime;

    let cutoff: Date | undefined;
    if (eventTime) {
        const withTime = new Date(`${eventDateStr} ${eventTime}`);
        if (!Number.isNaN(withTime.getTime())) {
            // Events older than 30 minutes should not be shown.
            withTime.setMinutes(withTime.getMinutes() + 30);
            cutoff = withTime;
        }
    }

    if (!cutoff) {
        // No usable time — treat the whole event day as upcoming until it ends.
        const dateOnly = new Date(eventDateStr);
        if (Number.isNaN(dateOnly.getTime())) {
            return false;
        }
        dateOnly.setHours(23, 59, 59, 999);
        cutoff = dateOnly;
    }

    return cutoff < new Date();
};
